import { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Button, Dialog } from '@mui/material';
import { BatchScheduleDetails } from './show/ScheduleDetails';
import ScheduleContent from './show/ScheduleContent';
import { useParams } from 'react-router';
import BatchStudentJoined from './show/BatchStudentJoined';
import LiveClassPreview from './LiveClassPreview';
import { goApi } from '../../services';
import { useRefresh } from 'react-admin';
import { ScheduleForm } from '../batches/batch-schedules/ScheduleForm';
import { useSearchParams } from 'react-router-dom';
import { Edit } from '@mui/icons-material';

const ScheduleEditButton = ({ schedule, refreshSchedule }: any) => {
    const [openModal, setOpenModal] = useState(false);
    const [searchParams] = useSearchParams();
    const query = Object.fromEntries(searchParams.entries());
    const templateId = query?.templateId;

    const refresh = useRefresh();
    return (
        <>
            <Button onClick={() => setOpenModal(true)}>
                <Edit />
            </Button>
            <Dialog
                open={openModal}
                title={'Schedule Form'}
                onClose={(_refresh: boolean) => {
                    setOpenModal(false);
                }}
            >
                <ScheduleForm
                    batchId={schedule?.batchId}
                    templateId={templateId}
                    schedule={schedule}
                    onClose={(_refresh: boolean) => {
                        if (_refresh) {
                            refreshSchedule();
                        }
                        setOpenModal(false);
                    }}
                />
            </Dialog>
        </>
    );
};

const BatchScheduleShow = () => {
    const { id } = useParams();
    const [currentTab, setCurrentTab] = useState(0);

    const [schedule, setSchedule] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const fetchSchedule = async () => {
        try {
            setLoading(true);
            const res = await goApi.get(`/batches/schedules/${id}`);
            setSchedule(res.data);
        } catch (err: any) {
            setError(err.message || 'Failed to load schedule');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!id) return;
        fetchSchedule();
    }, [id]);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    return (
        <div className="border rounded-xl p-4 my-4 min-h-[80vh]">
            <div className="flex justify-end">
                <ScheduleEditButton schedule={schedule} refreshSchedule={fetchSchedule} />
            </div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className="flex flex-wrap" value={currentTab} onChange={handleTabChange}>
                    <Tab label="Details" />
                    <Tab label="Homeworks" />
                    <Tab label="Exercise" />
                    <Tab label="Watch Stats" />
                    <Tab label="Live Chat" />
                </Tabs>
            </Box>
            <div className="p-3">
                {currentTab === 0 && (
                    <div>
                        <BatchScheduleDetails schedule={schedule} loading={loading} error={error} />
                    </div>
                )}
                {currentTab === 1 && (
                    <div>
                        <ScheduleContent type="pdf" />
                    </div>
                )}
                {currentTab === 2 && (
                    <div>
                        <ScheduleContent type="exercise" />
                    </div>
                )}
                {currentTab === 3 && (
                    <div>
                        <BatchStudentJoined schedule={schedule} />
                    </div>
                )}
                {currentTab === 4 && <LiveClassPreview scheduleId={id} />}
            </div>
        </div>
    );
};

export default BatchScheduleShow;
